import Notifications from './Notifications';

export default Notifications;
export type { INotification } from './INotification';
